import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '~/services/queryClient'
import { getTasksConversations } from '~/services/superAdminService'

export interface TaskConversation {
  id: number
  uuid: string
  title: string
  task_count: number
  message_count: number
  first_task_type: string | null
  mode: string | null
}

interface UseConversationsListProps {
  orgId: number | null
}

const useConversationsList = ({ orgId }: UseConversationsListProps) => {
  const { data: conversationsList, isLoading } = useQuery({
    queryKey: [orgId, ...QueryKeys.AdminConversationsList],
    queryFn: ({ queryKey }) => getTasksConversations(queryKey[0] as number),
    enabled: !!orgId,
    staleTime: 0,
    meta: {
      persist: false
    },
    select: data => (data?.conversations as TaskConversation[]) || []
  })

  return { conversations: conversationsList ?? [], isLoading }
}

export default useConversationsList
